import { render, staticRenderFns } from "./UserOutline.vue?vue&type=template&id=2c128595&"
import script from "./UserOutline.vue?vue&type=script&lang=ts&"
export * from "./UserOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports